import React, { useContext, useState, Suspense } from "react";
import { useEffect } from "react";
import config from "../../services/config.json";
import BuyBtn from "../Buttons/BuyBtn";
import SimpleContext from "./../context/SimpleContext";
import search1 from "../img/search.png";
import cross from "../img/cross.png";
import Preloader from "../Preloader/preloader";
import Preloader2 from "../Preloader/preloader2";
import InfiniteScroll from "react-infinite-scroll-component";
// import "./categories.css";
import { Button, Modal } from "react-bootstrap";
import useLocalStorageState from "use-local-storage-state";
// import SearchBrands from "./SearchBrands";
import { useHistory } from "react-router-dom";
import NumberFormat from "react-number-format";
import brands from "./../img/brands.png";
import Basket from "../img/Basket.png";
const BrandsProducts = () => {
  const context = useContext(SimpleContext);
  const [page, setpage] = useState(0);
  const [showModal, setshowModal] = useState(false);
  const [img, setimg] = useState([]);
  const [search, setsearch] = useState(false);
  const [sortName, setsortName] = useState("");
  const history = useHistory();

  //   let styleSearch;
  //   if (context.searchProducts.brandList.length > 0 && context.showBrand===false) {
  //     styleSearch = {
  //       marginTop: "230px",
  //     };
  //   } else {
  let styleSearch = {
    marginTop: "200px",
  };
  //   }
  let filterOrSortPartBrands2;
  if (context.category !== null && context.category !== undefined) {
    if (context.category.length > 0) {
      filterOrSortPartBrands2 = {
        width: "100%",
        position: "relative",
        marginRight: "10px",
        height: "70px",
      };
    } else {
      filterOrSortPartBrands2 = {
        width: "100%",
        position: "relative",
        marginRight: "10px",
        height: "0",
      };
    }
  }
  //فراخانی وب سرویس sortorder
  useEffect(() => {
    context.sortOrder();
    if (context.List.length > 0) {
      let name;
      name = context.List.find((i) => i.id === context.sort);
      setsortName(name.title);
    }
  }, []);

  // فراخانی وب سرویس جستجوی محصولات پس از اضافه شدن پیج
  useEffect(() => {
    if (page !== 0) {
      context.setsearchBodyOfProduct({});
      context.search(
        page,
        context.SearchField,
        0,
        0,
        context.SelectedBrandsList,
        context.sort,
        0,
        0,
        0,
        context.searchBodyOfProduct
      );
      context.categories(0, context.SelectedBrandsList);
    }
  }, [page]);

  //فرخانی وب سرویس پروداکت در زمان ورود به صفحه
  useEffect(() => {
    context.setsearchBodyOfProduct({});
    setpage(0);
    context.search(
      0,
      context.SearchField,
      0,
      0,
      context.SelectedBrandsList,
      context.sort,
      0,
      0,
      0,
      context.searchBodyOfProduct
    );
    context.categories(0, context.SelectedBrandsList);
  }, []);

  //برای هندل کردن ارور عکس ها
  const addDefaultSrc = (ev) => {
    ev.target.src = "/images/placeholder.jpg";
  };

  // let filteredCats = context.category.filter((cat) => cat.ID !== 9);
  //تابع برای فراخانی محصو.لات بیشتر با استفاده ار پیجینیشن
  const fetchData = () => {
    setTimeout(() => {
      setpage(page + 1);
    }, 150);
  };

  //تابع برای نمایش مودال که عکس هارا نشان میدهد
  const ModalImage = (img) => {
    setshowModal(true);
    setimg(img);
  };
  //برای جست وجو با اینتر
  function handleKeyPress(e) {
    if (e.key === "Enter") {
      setsearch(true);
      context.setshow(false);
      HandleSearch();
    }
  }

  //تابع برای سرچ محصولات
  const searchh = () => {
    HandleSearch();
  };
  const HandleSearch = () => {
    context.setsearchBodyOfProduct({});
    context.setTreeMenuSelectedId(0);
    context.setFilterPriceRange([0, 0]);
    context.search(
      0,
      context.SearchField,
      0,
      0,
      context.SelectedBrandsList,
      context.sort,
      0,
      0,
      0,
      context.searchBodyOfProduct
    );
    context.categories(0, context.SelectedBrandsList);
  };

  //تابع برای حذف کردن مقدار سرچ شده
  const HandlecleareAllAndReload = () => {
    context.setsearchBodyOfProduct({});
    context.setTreeMenuSelectedId(0);
    context.setSearchField("");
    context.setFilterPriceRange([0, 0]);
    setpage(0);
    context.search(
      0,
      "",
      0,
      0,
      context.SelectedBrandsList,
      context.sort,
      0,
      0,
      0,
      context.searchBodyOfProduct
    );
    context.categories(0, context.SelectedBrandsList);
  };

  //نمایش محصولات ساب کتگوری ها
  const goSub2 = (name, id) => {
    context.setsearchProducts({});
    context.setjustFav(0);
    context.setsearchBodyOfProduct({});
    context.setshowCatId(id);
    context.setheaderCat(name);
    context.categories(id, []);
    context.setsearchBodyOfProduct({});
    context.search(
      0,
      context.SearchField,
      0,
      id,
      context.SelectedBrandsList,
      context.sort,
      0,
      0,
      0,
      context.searchBodyOfProduct
    );
    history.push("/CategoriesProducts");
  };

  //رفتن به صفحه جزییات محصول با شناسه کاربر
  const ShowProductInfo = (product) => {
    if (parseInt(product.stock) === 0 || parseInt(product.stock) < 0) {
      context.Handelerror(product.stockToast);
    } else {
      history.push(`/product/${product.productRef}`);
      context.setproductRoight(product.productRef);
    }
  };

  return (
    <>
      {Object.values(context.searchProducts).length === 0 ? (
        <Preloader />
      ) : (
        <>
          {context.showPre === true && page === 0 ? (
            <Preloader />
          ) : (
            <div
              style={{
                display: "flex",
                width: "97%",
                flexDirection: "column",
                textAlign: "center",
              }}
            >
              <div className="searchCat">
                <div
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "center",
                    alignItem: "center",
                    textAlign: "center",
                    gap: "10px",
                    width: "100%",
                    textAlign: "right",
                    fontWeight: "bold",
                    fontSize: "13px",
                    marginTop: "10px",
                  }}
                >
                  <div
                    style={{ position: "relative" }}
                    id="ss"
                    className="searchPart"
                  >
                    <button type="submit" className="btn btn-sm">
                      <img
                        onClick={() => searchh()}
                        alt="آیکون"
                        src={search1}
                        style={{ width: "20px" }}
                      />
                    </button>
                    <input
                      onChange={(e) => context.setSearchField(e.target.value)}
                      onKeyDown={(e) => handleKeyPress(e)}
                      className="searchInput"
                      type="text"
                      placeholder={
                        context.SearchField !== ""
                          ? context.SearchField
                          : "جستجوی محصول"
                      }
                      style={{
                        border: "none",
                        backgroundColor: "#d9d6d6",
                        color: "gray",
                        fontSize: "15px",
                        outline: "none",
                        width: "100%",
                        textAlign: "right",
                        fontWeight: "bold",
                        fontSize: "13px",
                      }}
                    />

                    <button type="submit" className="btn btn-sm">
                      <img
                        onClick={() => HandlecleareAllAndReload()}
                        src={cross}
                        style={{
                          fontSize: "24px",
                          width: "15px",
                          margin: "2px 0 0 0 ",
                        }}
                      />
                    </button>
                  </div>
                  <div className="searchPart2">
                    <img style={{ width: "25px" }} src={Basket} />
                    {context.BadgeOfBasket > 0 && (
                      <div
                        onClick={() => history.push("/Buy")}
                        style={{
                          width: "22px",
                          position: "absolute",
                          bottom: "9px",
                          height: "20px",
                          borderRadius: "50px",
                          backgroundColor: "#ff7014",
                          justifyContent: "center",
                          textAlign: "center",
                          alignItems: "center",
                          color: "#fff",
                          fontSize: "14px",
                          left: "1px",
                        }}
                      >
                        <p style={{ margin: "0" }}>{context.BadgeOfBasket}</p>
                      </div>
                    )}
                  </div>
                </div>

                {/* { (
              <div className="filterOrSortPart">
                {context.SearchField !== "" ? (
                  <p
                    style={{
                      width: "100%",
                      display: "flex",
                      justifyContent: "flex-start",
                      margin: "0",
                      alignItems: "center",
                      fontWeight: "bold",
                      paddingRight: "6%",
                      color: "gray",
                    }}
                  >{`نتایج جستجوی : ${context.SearchField}`}</p>
                ) : (
                  <p
                    style={{
                      width: "100%",
                      display: "flex",
                      justifyContent: "flex-start",
                      margin: "0",
                      alignItems: "center",
                      fontWeight: "bold",
                      paddingRight: "6%",
                      color: "gray",
                    }}
                  >
                    کالاهای پیشنهادی
                  </p>
                )}
              </div>
            )} */}

                <div
                  style={{ borderBottom: "1px solid #e5e5e5" }}
                  className="FilterOrSort"
                >
                  <p style={{ margin: "0", color: "gray", fontSize: "14px" }}>
                    {context.brandName}
                  </p>
                </div>

                {/* نمایش ساب کتگوری ها */}
                {context.category !== null && context.category !== undefined ? (
                  context.category.length > 0 ? (
                    <div
                      style={filterOrSortPartBrands2}
                      className="filterOrSortPartBrands2"
                    >
                      <div
                        style={{
                          width: "150px",
                          position: "relative",
                          marginRight: "10px",
                        }}
                      >
                        <img style={{ width: "100%" }} src={brands} />
                        <p
                          style={{
                            position: "absolute",
                            top: "12px",
                            right: "20px",
                            color: "#fff",
                          }}
                        >
                          گروه کالایی
                        </p>
                      </div>

                      <div
                        style={{
                          width: "80%",
                          display: "flex",
                          flexDirection: "row",
                          overflowY: "scroll",
                          height: "100%",
                          justifyContent: "flex-start",
                          textAlign: "center",
                          alignItems: "center",
                        }}
                      >
                        {context.category.map((i) => {
                          return (
                            <div
                              onClick={() => goSub2(i.productGroupName, i.id)}
                              className="brands2"
                            >
                              <p
                                style={{
                                  margin: "0",
                                  fontWeight: "bold",
                                  fontSize: "12px",
                                  minWidth: "100px",
                                }}
                              >
                                {i.productGroupName}
                              </p>
                              <img
                                className="imgSub"
                                onError={addDefaultSrc}
                                src={i.imageUrl}
                              />
                            </div>
                          );
                        })}
                      </div>
                    </div>
                  ) : null
                ) : null}
              </div>

              {context.searchProducts !== null &&
              context.searchProducts !== undefined
                ? Object.values(context.searchProducts).length > 0 && (
                    <InfiniteScroll
                      className="InfiniteScroll"
                      style={{
                        overflow: "hidden",
                      }}
                      dataLength={context.searchProducts.productLists.length}
                      next={fetchData}
                      hasMore={true}
                    >
                      {context.searchProducts.productLists.length === 0 ? (
                        <>
                          <img
                            alt="placeHolder"
                            src="/images/place_holder_cat_search.png"
                            style={{
                              marginTop: "60%",
                              width: "50%",
                              maxWidth: "200px",
                            }}
                          />
                          <p style={{ fontWeight: "bold" }}>
                            کالایی موجود نیست!
                          </p>
                        </>
                      ) : (
                        <div
                          // style={styleSearch}
                          className={
                            context.showPre === false
                              ? "categoriesdiv"
                              : "categoriesdivWidthPage"
                          }
                        >
                          {context.searchProducts !== null &&
                          Object.values(context.searchProducts).length > 0
                            ? context.searchProducts.productLists.map((i) => (
                                <>
                                  <div key={i.productCode} className="category">
                                    <div
                                      style={{
                                        width: "100%",
                                        maxWidth: "100%%",
                                        display: "flex",
                                        justifyContent: "flex-start",
                                        alignItems: "center",
                                        textAlign: "center",
                                        flexDirection: "row",
                                        gap: "4.5px",
                                      }}
                                    >
                                      <div
                                        style={{
                                          width: "40%",
                                        }}
                                      >
                                        <img
                                          onClick={() => ModalImage(i.imageUrl)}
                                          onError={addDefaultSrc}
                                          style={{
                                            width: "100%",
                                            height: "100%",
                                          }}
                                          src={i.imageUrl}
                                          className={
                                            parseInt(i.stock) === 0 ||
                                            parseInt(i.stock) < 0
                                              ? "namojud"
                                              : "mojud"
                                          }
                                        />
                                      </div>

                                      <div
                                        className="mainRowCat"
                                        style={{ width: "60%", gap: "5px" }}
                                      >
                                        <div
                                          onClick={() => ShowProductInfo(i)}
                                          className="itemProduct"
                                        >
                                          <p
                                            style={{
                                              color: "gray",
                                              fontWeight: "bold",
                                              margin: "0",
                                            }}
                                          >
                                            {i.brandName}
                                          </p>
                                        </div>

                                        <div
                                          onClick={() => ShowProductInfo(i)}
                                          className="itemProduct"
                                        >
                                          <p
                                            style={{
                                              display: "flex",
                                              textAlign: "right",
                                              fontWeight: "bold",
                                              margin: "0",
                                              fontSize: "14px",
                                            }}
                                          >
                                            {i.productName}
                                          </p>
                                        </div>

                                        <div
                                          onClick={() => ShowProductInfo(i)}
                                          style={{
                                            justifyContent: "space-between",
                                          }}
                                          className="itemProduct"
                                        >
                                          <p
                                            style={{
                                              fontSize: "12px",
                                              fontWeight: "bold",
                                              color: "gray",
                                              margin: "0",
                                            }}
                                          >
                                            قیمت مصرف کننده
                                          </p>

                                          <p
                                            style={{
                                              fontSize: "12px",
                                              fontWeight: "bold",
                                              color: "gray",
                                              margin: "0",
                                            }}
                                          >
                                            قیمت پایه
                                          </p>
                                        </div>

                                        <div
                                          onClick={() => ShowProductInfo(i)}
                                          style={{
                                            justifyContent: "space-between",
                                          }}
                                          className="itemProduct"
                                        >
                                          <p
                                            style={{
                                              fontWeight: "bold",
                                              margin: "0",
                                            }}
                                          >
                                            {" "}
                                            <NumberFormat
                                              value={i.userPrice}
                                              displayType={"text"}
                                              thousandSeparator={true}
                                            />{" "}
                                            ریال
                                          </p>

                                          <p
                                            style={{
                                              fontWeight: "bold",
                                              margin: "0",
                                            }}
                                          >
                                            <NumberFormat
                                              value={i.price}
                                              displayType={"text"}
                                              thousandSeparator={true}
                                            />{" "}
                                            ریال
                                          </p>
                                        </div>
                                      </div>
                                    </div>

                                    <div
                                      style={{
                                        width: "100%",
                                        maxWidth: "100%",
                                        display: "flex",
                                        flexDirection: "row",
                                        justifyContent: "flex-end",
                                        gap: "10px",
                                      }}
                                    >
                                      <div
                                        style={{
                                          width: "40%",
                                          height: "120px",
                                          height: "100%",
                                        }}
                                      >
                                        {i.hasDiscountOffer !== "" ? (
                                          <button
                                            onClick={() => ShowProductInfo(i)}
                                            className="ButtonBtnDis"
                                            style={{
                                              width: "100%",

                                              borderRadius: "50px",
                                              border: "1px solid #ff7014",
                                              backgroundColor: "#ff7014",
                                              color: "#fff",
                                              fontWeight: "lighter",
                                            }}
                                          >
                                            {i.hasDiscountOffer}
                                          </button>
                                        ) : null}
                                      </div>

                                      <div
                                        style={{
                                          width: "30%",
                                          fontWeight: "bold",
                                          fontSize: "14px",
                                        }}
                                        className="itemProductRow"
                                      >
                                        {i.basketSelection === "0" ||
                                        i.basketSelection === 0
                                          ? `${i.unitName}`
                                          : `${i.basketSelection}${i.unitName}`}
                                      </div>

                                      <div
                                        style={{ width: "30%", height: "100%" }}
                                        className="itemProductRow"
                                      >
                                        <BuyBtn Product={i} />
                                      </div>
                                    </div>
                                  </div>
                                </>
                              ))
                            : null}
                        </div>
                      )}
                      {context.showPre === true ? (
                        <div
                          style={{
                            width: "100%",
                            display: "flex",
                            justifyContent: "center",
                            textAlign: "center",
                            alignAitem: "center",
                            marginBottom: "80px",
                            height: "80px",
                          }}
                        >
                          <p
                            style={{
                              width: "100%",
                              display: "flex",
                              justifyContent: "center",
                              textAlign: "center",
                              alignAitem: "center",
                              margin: "0",
                            }}
                          >
                            <Preloader2 />
                          </p>
                        </div>
                      ) : null}
                    </InfiniteScroll>
                  )
                : null}
            </div>
          )}

          <Modal style={{ marginTop: "180px" }} show={showModal}>
            <div
              style={{
                width: "100%",
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
                textAlign: "center",
              }}
            >
              <img
                onError={addDefaultSrc}
                style={{ width: "100%" }}
                src={img}
              />
              <Button
                onClick={() => setshowModal(false)}
                style={{
                  width: "90%",
                  backgroundColor: "#ff7014",
                  color: "#fff",
                  height: "5vh",
                  border: "none",
                  margin: "10px 0 10px 0",
                  display: "flex",
                  justifyContent: "center",
                  textAlign: "center",
                  alignAitem: "center",
                }}
              >
                بستن
              </Button>
            </div>
          </Modal>
        </>
      )}
    </>
  );
};

export default BrandsProducts;
